import React, { useEffect, useState } from "react";
import ProgressBar from "./ProgressBar";
import axios from "axios";
import base_url from "./../../../api/bootapi";
import { useStateValue } from "../ContextAPI/StateProvider";
import { useHistory } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import DeviceSettinggps from "../../../Modal/DeviceSettingGPS/DeviceSettinggps";
import DeviceSettingobd from "../../../Modal/DeviceSettingOBD/DeviceSettingobd";
import { Modal } from "react-bootstrap";

const ConfirmPageForm = () => {
  const { addToast } = useToasts();
  const [
    {
      backupCustomerInformation,
      backupactivationType,
      backuppaymentMethod,
      servicePlan,
      servicePlanGPS,
    },
    dispatch,
  ] = useStateValue();
  const customerInformation = JSON.parse(
    sessionStorage.getItem("customerInformation")
  );
  const activationType = JSON.parse(sessionStorage.getItem("activationType"));
  const paymentMethod = JSON.parse(sessionStorage.getItem("paymentMethod"));
  const [message, setmessage] = useState();
  const [error, seterror] = useState(false);
  const [successerror, setsuccesserror] = useState(false);
  const [successerrormessage, setsuccesserrormessage] = useState(false);
  const history = useHistory();
  const [loading, setloading] = useState(true);
  const [userdetail, setuserdetail] = useState({});
  const [devicedetail, setdevicedetail] = useState([]);
  const [confirmationarr, setconfirmationarr] = useState([]);
  const [show, setshow] = useState(false);
  const [token, settoken] = useState("");

  useEffect(() => {
    /* eslint-disable react-hooks/exhaustive-deps */
    if (!JSON.parse(sessionStorage.getItem("movetoconfirmpage"))) {
      history.push("/registration/customer-information");
      addToast(
        "Error! You cannot proceed furthur before filling previous details",
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
    } else {
      checkforconfirmation();
    }
  }, []);

  const gettotalprice = () => {
    let price = 0;
    confirmationarr.forEach((ele) => {
      price += Number(ele.price);
    });
    return price;
  };
  const checkforconfirmation = () => {
    let arr = [];
    activationType.devices.forEach((ele) => {
      arr.push({
        name: ele["plan_name"],
        price: ele["price"],
      });
    });
    setconfirmationarr(arr);
    setshow(true);
  };
  const continueresult = () => {
    setshow(false);
    sessionStorage.setItem("shownavigationthroughtopbar", false);
    sessionStorage.setItem("movetoactivationpage", false);
    sessionStorage.setItem("movetopaymentpage", false);
    sessionStorage.setItem("movetotermspage", false);
    dispatch({
      type: "ADD_TO_TOPBARNAVIGATION",
      shownavigationthroughtopbar: false,
    });
    getresult();
  };
  const getresult = () => {
    let first_name = customerInformation.firstName;
    let last_name = customerInformation.lastName;
    let email = customerInformation.email;
    let company = customerInformation.companyName;
    let phone_number = customerInformation.phone;
    let password = customerInformation.password;
    let comfirm_email = customerInformation.confirmEmail;
    let state = customerInformation.state;
    let city = customerInformation.city;
    let address = customerInformation.billingAddress;
    let country = customerInformation.country;
    let zip = customerInformation.zipcode;
    let time_zone = customerInformation.timezone;
    let time_zone_description = customerInformation.timezonedescription;
    // let service_plan = activationType.servicePlan;
    let uom = activationType.unit;
    let mobile_carrier;
    if (customerInformation.serviceProvider === "Others") {
      mobile_carrier = customerInformation.customserviceProvider;
    } else {
      mobile_carrier = customerInformation.serviceProvider;
    }
    let credit_card = {
      cardholder_name: paymentMethod.cardHoldername,
      cvv: paymentMethod.cvc,
      expiration_date: `${paymentMethod.expirationdatemonth}/${paymentMethod.expirationdateyear}`,
      number: paymentMethod.cardnumber,
    };
    let devices = [];
    let obj = {};
    let activationdevices = activationType.devices;
    for (let i = 0; i < activationdevices.length; i++) {
      obj[activationdevices[i].imei] = activationdevices[i].category;
      let devicedata = {
        imei: activationdevices[i].imei,
        device_name: activationdevices[i].device_name,
        device_model: activationdevices[i].device_model,
        device_plan: activationdevices[i].servicePlan,
      };
      devices.push(devicedata);
    }
    let data;
    if (JSON.parse(sessionStorage.getItem("userexists"))) {
      data = {
        email,
        language: "English",
        // service_plan,
        devices,
        uom,
      };
      if (paymentMethod["token"]) {
        data["user_token"] = paymentMethod["token"];
        data["card_bin"] = paymentMethod["bin"];
        data["card_last_4"] = paymentMethod["last_4"];
      } else {
        data["credit_card"] = credit_card;
      }
    } else {
      data = {
        first_name,
        last_name,
        email,
        company,
        phone_number,
        password,
        comfirm_email,
        state,
        city,
        mobile_carrier,
        language: "English",
        address,
        country,
        zip,
        time_zone,
        time_zone_description,
        // service_plan,
        credit_card,
        devices,
        uom,
      };
    }
    checkresult(data, obj);
  };
  const checkresult = (data, obj) => {
    axios
      .post(`${base_url}/auth/register`, data)
      .then((res) => {
        if (res.data.status) {
          if (res.data.error) {
            let price = 0;
            res.data.subscription.forEach((item) => {
              if (servicePlan?.[item["activated_plan_id"]]?.["price"]) {
                price += Number(
                  servicePlan?.[item["activated_plan_id"]]?.["price"]
                );
              } else if (
                servicePlanGPS?.[item["activated_plan_id"]]?.["price"]
              ) {
                price += Number(
                  servicePlanGPS?.[item["activated_plan_id"]]?.["price"]
                );
              }
            });
            setsuccesserrormessage(
              `(Attention!) You will only incur a charge of $${price} for the activated/registered devices. For any inquiries, please reach out to our support team at gps@amcrest.com.`
            );
          }
          setsuccesserror(res.data.error);
          setmessage(res.data.message);
          setuserdetail(res.data.details);
          res.data.subscription.forEach((item) => {
            item["category"] = obj[item.imei_no];
          });
          setdevicedetail(res.data.subscription);
          settoken(res.data.token);
          addToast("Device Registered Successfully", {
            appearance: "success",
            autoDismiss: true,
          });
          sessionStorage.setItem("movetoconfirmpage", true);
        } else {
          setmessage(res.data.message);
          addToast(`Error ${res.data.message}`, {
            appearance: "error",
            autoDismiss: true,
          });
          seterror(true);
          sessionStorage.setItem("shownavigationthroughtopbar", true);
          sessionStorage.setItem("movetoactivationpage", true);
          sessionStorage.setItem("movetopaymentpage", true);
          sessionStorage.setItem("movetotermspage", true);
        }
        setloading(false);
      })
      .catch((err) => {
        if (err.response) {
          let error = err.response.data.message;
          if (err.response.data.error) {
            error = error + " : " + err.response.data.error;
          }
          setmessage(error);
          addToast(`Error ${error}`, {
            appearance: "error",
            autoDismiss: true,
          });
        } else {
          setmessage("SomeThing Went Wrong");
          addToast("Error! SomeThing Went Wrong", {
            appearance: "error",
            autoDismiss: true,
          });
        }
        setloading(false);
        seterror(true);
        sessionStorage.setItem("shownavigationthroughtopbar", true);
        sessionStorage.setItem("movetoactivationpage", true);
        sessionStorage.setItem("movetopaymentpage", true);
        sessionStorage.setItem("movetotermspage", true);
      });
  };
  const resetall = () => {
    dispatch({
      type: "ADD_TO_CUSTOMERINFORMATION",
      customerInformation: backupCustomerInformation,
    });
    dispatch({
      type: "ADD_TO_ACTIVATIONTYPE",
      activationType: backupactivationType,
    });
    dispatch({
      type: "ADD_TO_PAYMENTMETHOD",
      paymentMethod: backuppaymentMethod,
    });
    dispatch({
      type: "ADD_TO_TERMS",
      terms: { checked: false },
    });
    dispatch({
      type: "ADD_TO_MOVETOACTIVATION",
      movetoactivationpage: false,
    });
    dispatch({
      type: "ADD_TO_MOVETOPAYMENT",
      movetopaymentpage: false,
    });
    dispatch({
      type: "ADD_TO_MOVETOTERMS",
      movetotermspage: false,
    });
    dispatch({
      type: "ADD_TO_MOVETOCONFIRM",
      movetoconfirmpage: false,
    });
    dispatch({
      type: "ADD_TO_USEREXIST",
      userexists: false,
    });
    sessionStorage.setItem(
      "customerInformation",
      JSON.stringify(backupCustomerInformation)
    );
    sessionStorage.setItem(
      "activationType",
      JSON.stringify(backupactivationType)
    );
    sessionStorage.setItem(
      "paymentMethod",
      JSON.stringify(backuppaymentMethod)
    );
    sessionStorage.setItem("movetoactivationpage", false);
    sessionStorage.setItem("movetopaymentpage", false);
    sessionStorage.setItem("movetotermspage", false);
    sessionStorage.setItem("movetoconfirmpage", false);
    sessionStorage.setItem("userexists", false);
    sessionStorage.setItem("shownavigationthroughtopbar", true);
    history.push("/registration/customer-information");
  };

  const goBack = () => {
    dispatch({
      type: "ADD_TO_MOVETOCONFIRM",
      movetoconfirmpage: false,
    });
    history.push("/registration/terms");
  };
  const gotoplanselection = () => {
    dispatch({
      type: "ADD_TO_MOVETOCONFIRM",
      movetoconfirmpage: false,
    });
    history.push("/registration/activation-type");
  };
  return (
    <form id="myForm">
      <div>
        <ProgressBar typeofactive="Confirm" />
        {loading ? (
          <img width={300} alt="loader" src="./loading.gif" />
        ) : (
          <>
            {error ? (
              <>
                <div className="alert alert-danger">
                  <strong>Error! </strong>
                  {message}
                </div>
                <div
                  className="activation"
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <button
                    className="btn "
                    style={{ backgroundColor: "#ccc", borderColor: "#ccc" }}
                    onClick={goBack}
                  >
                    Previous
                  </button>
                </div>
              </>
            ) : (
              <>
                <div className="alert alert-success">
                  <strong>Success! </strong>
                  {message}
                </div>
                <div>
                  <p className="text-center" style={{ fontWeight: "bold" }}>
                    Registration Details{" "}
                  </p>
                  <p className="marginp text-left">
                    <div className="row">
                      <div className="col-md-4">Name :</div>
                      <div className="col-md-8">
                        {userdetail?.first_name} {userdetail?.last_name}
                      </div>
                    </div>
                  </p>
                  <p className="marginp text-left">
                    <div className="row">
                      <div className="col-md-4">Email :</div>
                      <div className="col-md-8">{userdetail?.email}</div>
                    </div>
                  </p>
                  <p className="text-left">
                    <div className="row">
                      <div className="col-md-4">Customer ID :</div>
                      <div className="col-md-8">{userdetail?.customer_id}</div>
                    </div>
                  </p>
                </div>
                <hr className="confirmpagehr" />
                <p
                  className="text-center"
                  style={{ fontWeight: "bold", marginTop: "10px" }}
                >
                  Device Details{" "}
                </p>
                {devicedetail?.map((item, index) => (
                  <div key={index + 1}>
                    <p
                      className="text-center"
                      style={{ fontWeight: "bold", marginTop: "10px" }}
                    >
                      {item.device_name}
                    </p>
                    <p className="marginp text-left">
                      <div className="row">
                        <div className="col-md-4">IMEI :</div>
                        <div className="col-md-8">{item.imei_no}</div>
                      </div>{" "}
                    </p>
                    <p className="marginp text-left">
                      <div className="row">
                        <div className="col-md-4">ICCID :</div>
                        <div className="col-md-8">{item.imei_iccid}</div>
                      </div>
                    </p>
                    <p className="marginp text-left">
                      <div className="row">
                        <div className="col-md-4">Subscription ID :</div>
                        <div className="col-md-8">{item.subscription_id}</div>
                      </div>
                    </p>
                    <p className="marginp text-left">
                      <div className="row">
                        <div className="col-md-4">
                          Subscription Start Date :
                        </div>
                        <div className="col-md-8">{item.start_date}</div>
                      </div>
                    </p>
                    <p className="marginp text-left">
                      <div className="row">
                        <div className="col-md-4">Next billing Date :</div>
                        <div className="col-md-8">{item.nextBillingDate}</div>
                      </div>
                    </p>
                    <p className="text-left">
                      <div className="row">
                        <div className="col-md-4">Active Plan :</div>
                        <div className="col-md-8">
                          {item.activated_plan_description}
                        </div>
                      </div>
                    </p>
                    {item.category === "gps" ? (
                      <DeviceSettinggps
                        token={token}
                        imei_no={item.imei_no}
                        planid={item.activated_plan_id}
                      />
                    ) : (
                      <DeviceSettingobd
                        token={token}
                        imei_no={item.imei_no}
                        planid={item.activated_plan_id}
                      />
                    )}
                    <hr className="confirmpagehr" />
                  </div>
                ))}
                {successerror && (
                  <div className="alert alert-danger mt-3">
                    We are facing issue during creating subscription for
                    following devices. Please try with different cards.
                  </div>
                )}
                {successerror &&
                  successerror.split("|").map((item) => (
                    <div className="alert alert-danger mt-3">
                      <strong>Error! </strong>
                      {item}
                    </div>
                  ))}
                {successerrormessage && (
                  <div className="alert alert-info mt-3">
                    <strong>Info! </strong>
                    {successerrormessage}
                  </div>
                )}
                <h3
                  style={{
                    margin: "20px 0",
                    color: "#0275d8",
                    cursor: "pointer",
                  }}
                  onClick={resetall}
                  className="text-center"
                >
                  Have more devices to activate?
                </h3>
                <h3
                  style={{
                    margin: "20px 0",
                    color: "#0275d8",
                  }}
                  className="text-center"
                >
                  OR
                </h3>
                <h3 className="text-center">
                  <a
                    target="blank"
                    href="https://amcrestgps.net"
                    className="btn btn-primary"
                  >
                    LOGIN
                  </a>
                </h3>
              </>
            )}
          </>
        )}
      </div>
      <Modal size="lg" backdrop="static" show={show}>
        <Modal.Header>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          You are choosing:
          {confirmationarr.map((ele, index) => (
            <p>
              {index + 1}. <strong>{ele.name}</strong> plan - so you will be
              charged <strong>USD {ele.price}</strong>.
            </p>
          ))}
          {confirmationarr.length > 0 && (
            <p>
              Total Billed: <strong>USD {gettotalprice()}</strong> instantly.
            </p>
          )}
          Are you sure want to continue?
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-success" onClick={continueresult}>
            Confirm
          </button>
          <button className="btn btn-danger" onClick={gotoplanselection}>
            Go Back
          </button>
        </Modal.Footer>
      </Modal>
    </form>
  );
};

export default ConfirmPageForm;
